import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import Bowser from "bowser";
import i18n from "../i18n";
import {
  getBannerDetails,
  getsession,
  getTaskDetails,
  getTaskList,
  getPageNameWithFallback,
} from "../utils/apis";
import { encodeUnicodeToBase64 } from "../utils/utilityfns";
import { useLocationStore } from "./locationStore";

function Hidden() {
 const { latitude, longitude, setLatitude, setLongitude } = useLocationStore();
  const location = useLocation();

  const [record, setRecord] = useState<number | null>(null);
  const [record1, setRecord1] = useState<number | null>(null);
  const [pageName, setPageName] = useState<string>("");
  const sessionStarted = useRef(false);
  const [readyForSession, setReadyForSession] = useState(false);
  const { id } = useParams();
  const task_id = id ? Number(window.atob(id)) : undefined;

  // --------------------- Browser details ---------------------
  const getBrowserDetails = (userAgent: string) => {
    const parsed = Bowser.parse(userAgent);
    let browserName = parsed.browser?.name || "unknown";
    let browserVersion = parsed.browser?.version || "unknown";

    if (browserName === "unknown" || browserVersion === "unknown") {
      const chromeMatch = userAgent.match(/Chrome\/([0-9.]+)/);
      const firefoxMatch = userAgent.match(/Firefox\/([0-9.]+)/);
      const safariMatch = userAgent.match(/Version\/([0-9.]+) Safari/);
      const edgeMatch = userAgent.match(/Edg\/([0-9.]+)/);

      if (chromeMatch) {
        browserName = "Chrome";
        browserVersion = chromeMatch[1];
      } else if (firefoxMatch) {
        browserName = "Firefox";
        browserVersion = firefoxMatch[1];
      } else if (safariMatch) {
        browserName = "Safari";
        browserVersion = safariMatch[1];
      } else if (edgeMatch) {
        browserName = "Edge";
        browserVersion = edgeMatch[1];
      }
    }
    return { browserName, browserVersion, parsed };
  };

  // --------------------- Save route to localStorage ---------------------


  // --------------------- Message listener for Salesforce iframe ---------------------
 useEffect(() => {
    const messageListener = (event: { data: any; }) => {
      const data = event.data;
      console.log("📩 Message received:", data);

      if (data?.event === "salesforcePage") {
        const staturl = data?.data?.url;
        console.log("Salesforce url received:", staturl);
localStorage.setItem("page_name", staturl);
        setPageName(staturl);

        try {
          // localStorage.setItem("page_name", staturl);
        } catch {
          // sessionStorage.setItem("page_name", staturl);
        }

        setReadyForSession(true);

        try {
          if (window.parent !== window && typeof window.parent.postMessage === "function") {
            window.parent.postMessage({ action: "pageNameUpdate", label: staturl }, "*");
          } else {
            console.log("⚠️ iOS: parent postMessage not available");
          }
        } catch (err) {
          console.error("❌ iOS postMessage error:", err);
        }
      }
    };

    window.addEventListener("message", messageListener);
    return () => window.removeEventListener("message", messageListener);
  }, []);

     const messageListener = useCallback((event: any) => {
    const data = event.data;

    if (data?.data?.latitude !== undefined && data?.data?.longitude !== undefined) {
      console.log("Geolocation received:", data.data.latitude, data.data.longitude);
      setRecord1(data.data.latitude);
      setRecord(data.data.longitude);

      localStorage.setItem("latitude", String(data.data.latitude));
      localStorage.setItem("longitude", String(data.data.longitude));
    }

    if (data?.event === "salesforceNotification") {
      const status = data?.data?.status;
      console.log("Salesforce notification event:", status);
      localStorage.setItem("notification_consent_status", status ? "1" : "0");
    }
    console.log(data, "sssssssssssssssssss")
    // if (data?.event === "salesforcePage") {
    //   const staturl = data?.data?.url;
    //   console.log("Salesforce url received:", staturl);

    //   setPageName(staturl);
    //   localStorage.setItem("page_name", staturl);

    //   // ✅ Trigger session start only when pageName is received
    //   setReadyForSession(true);

    //   window.parent.postMessage({ action: "pageNameUpdate", label: staturl }, "*");
    // }


    if (data?.action === "geoLocation") {
      console.log("Received geoLocation action:", data.label);
    }
  }, []);

  useEffect(() => {
    console.log("Hidden component mounted, adding message listener");
    window.addEventListener("message", messageListener);

    return () => {
      console.log("Hidden component unmounted, removing message listener");
      window.removeEventListener("message", messageListener);
      localStorage.removeItem("latitude");
      localStorage.removeItem("longitude");
    };
  }, [messageListener]);



  console.log(record1, "record1sssssss", record, "recordsss33");
  const latitude1 = localStorage.getItem("latitude");
  const longitude1 = localStorage.getItem("longitude");

  // --------------------- Main session logic ---------------------
  useEffect(() => {
    if (sessionStarted.current) return;
    sessionStarted.current = true;
    const queryParams = new URLSearchParams(location.search);
    const userAgent = window.navigator.userAgent;
    const { browserName, browserVersion, parsed } = getBrowserDetails(userAgent);

    console.log("Parsed UA:", parsed);
    console.log("UserAgent string:", userAgent);

    const device_os_name = parsed.os?.name || "unknown";
    const device_os_version = parsed.os?.version || "unknown";

    // ---- Function: Handle Notification Permission ----
    const handleNotificationPermission = async (): Promise<"1" | "0"> => {
      try {
        let value: "1" | "0" = "0";

        if (Notification.permission === "default") {
          const permission = await Notification.requestPermission();
          value = permission === "granted" ? "1" : "0";
        } else if (Notification.permission === "granted") {
          value = "1";
        } else if (Notification.permission === "denied") {
          value = "0";
        }

        const salesforceValue = localStorage.getItem("notification_consent_status");
        const finalValue = salesforceValue ?? value;

        localStorage.setItem("notification_consent_status", finalValue);
        return finalValue as "1" | "0";
      } catch {
        return "0";
      }
    };
    // ---- Function: Handle Location Permission ----
    const handleLocationPermission = async () => {
      let locationConsentValue = "0";

      try {
        const coords = await new Promise<GeolocationPosition | null>((resolve) => {
          if (!navigator.geolocation) {
            console.warn("Geolocation API not supported");
            resolve(null);
            return;
          }

          navigator.geolocation.getCurrentPosition(
            (pos) => resolve(pos),
            (err) => {
              console.warn("❌ Location access denied:", err);
              resolve(null);
            },
            { timeout: 7000 }
          );
        });

        if (coords?.coords?.latitude && coords?.coords?.longitude) {
          const lat = coords.coords.latitude;
          const lon = coords.coords.longitude;

          localStorage.setItem("latitude", String(lat));
          localStorage.setItem("longitude", String(lon));
          localStorage.setItem("location_consent_status", "1");

          // setLatitude(lat);
          // setLongitude(lon);
          locationConsentValue = "1";
        } else {
          localStorage.setItem("location_consent_status", "0");
          locationConsentValue = "0";
        }
      } catch (err) {
        console.error("Error while checking location permission:", err);
      }

      return locationConsentValue;
    };


    // ---- Function: Start Session After Permissions ----
    const startSession = async () => {
      const notificationConsent = await handleNotificationPermission();
      const locationConsent = await handleLocationPermission();
      // Use improved page name handling with iOS fallbacks
      const pageName = getPageNameWithFallback();

      console.log("Device/Browser Info:", {
        device_os_name,
        device_os_version,
        browserName,
        browserVersion,
        notificationConsent,
        locationConsent,
        pageName,
        task_id
      });

      const params: any = {};
      queryParams.forEach((value, key) => {
        params[key] = value;
      });

      if (params["query"]) {
        getsession(
          params["query"],
          userAgent,
          latitude1 || undefined,
          longitude1 || undefined,
          device_os_version || "unknown",
          browserName || "unknown",
          browserVersion || "unknown",
          notificationConsent,
          locationConsent || "0",
          pageName,
          task_id
        )
          .then(async (result) => {
            console.log("Session result:", result);
            const { token, data } = result;
            const accId = data?.User?.Contact?.AccountId || undefined;
            const city = data?.User?.Contact?.Account?.BillingAddress?.city || undefined;
            const contactId = data?.User?.ContactId || undefined;
            const lang = data?.User?.LanguageLocaleKey || undefined;
localStorage.setItem("CONTACTID", data?.User?.ContactId);
localStorage.setItem("LANGUAGELOCALEKEY", data?.User?.LanguageLocaleKey);
//             localStorage.setItem("LANGUAGELOCALEKEY", data?.User?.LanguageLocaleKey);
            // localStorage.setItem("LANGUAGELOCALEKEY", data?.User?.LanguageLocaleKey);
            localStorage.setItem("token", token);
            console.log(token, "tokennnnnn");


            window.parent.postMessage({ action: "storeToLocal", label: city }, "*");

            console.log("navigator.appVersion:", navigator.appVersion);
            console.log("navigator.userAgent:", navigator.userAgent);
            console.log("navigator.platform:", navigator.platform);

            if (token && accId) {
              try {
                // ---- Fetch Task Details ----
                const taskDetails = await getTaskDetails(contactId);
                if (taskDetails.data?.length > 0) {
                  window.parent.postMessage(
                    {
                      action: "currentActive",
                      label: encodeUnicodeToBase64(
                        JSON.stringify(taskDetails.data)
                      ),
                    },
                    "*"
                  );
                }

                // ---- Fetch Task List ----
                const taskListData = await getTaskList(token);
                console.log(localStorage.getItem("LANGUAGELOCALEKEY"), "languagelocalekeyyyyyyy");
//                 const taskListData = await getTaskList(token);
                // const taskListData = await getTaskList(token);
                if (taskListData && typeof taskListData === "object") {
                  window.parent.postMessage(
                    {
                      action: "allActive",
                      label: encodeUnicodeToBase64(
                        JSON.stringify(taskListData.active_tasks.tasks || [])
                      ),
                    },
                    "*"
                  );
                } else {
                  console.error("Task list data format incorrect:", taskListData);
                }

                // ---- Fetch Banner Details ----
                const bannerData = await getBannerDetails(
                  { type: "banners", locations: [city] },
                  token
                );
                if (bannerData && typeof bannerData === "object") {
                  window.parent.postMessage(
                    {
                      action: "bannerData",
                      label: encodeUnicodeToBase64(JSON.stringify(bannerData || [])),
                    },
                    "*"
                  );
                } else {
                  console.error("Banner data format incorrect:", bannerData);
                }

                // ---- Fetch Notifications ----
                const response = await fetch(
                  `${process.env.REACT_APP_BASE_URL}/answer/fetch-notifications?type=notification`,
                  {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                      "Accept-Language": i18n.language,
                      Authorization: `Bearer ${token}`,
                    },
                  }
                );

                if (!response.ok) throw new Error("Network response was not ok");

                const notificationData = await response.json();
                window.parent.postMessage(
                  {
                    action: "notification",
                    label: encodeUnicodeToBase64(
                      JSON.stringify(notificationData.data || [])
                    ),
                  },
                  "*"
                );
              } catch (error) {
                console.error("Failed to fetch data:", error);
              }
            }
          })
          .catch((error) => {
            console.error("Session error:", error);
          });
      }
    };

    // ---- Execute session start ----
    startSession();
  }, []);
  //[location, latitude1, longitude1]);

  return (
    <>
      <div style={{ display: "none" }}>Hidden</div>
    </>
  );
}

export default Hidden;